import React from "react";
import "./Politicas.css";
import Footer from "../Footer/Footer";

export default function Politicas() {
  const lastUpdated = "16 de septiembre de 2025"; // actualizá si hace falta

  return (
    <>
      <main className="pp-root" role="main">
      <article className="pp-card">
        <header className="pp-header">
          <h1>Política de Privacidad</h1>
          <p className="pp-meta">Última actualización: {lastUpdated}</p>
        </header>

        <section>
          <h2>Introducción</h2>
          <p>
            Bienvenida/o. En <strong>Sole Costilla</strong> (en adelante "nosotros", "nuestro/a") respetamos su privacidad.
            Esta Política de Privacidad explica qué datos recogemos, por qué lo hacemos y cómo los protegemos cuando contratas servicios
            de fotografía, visitas nuestra web o te comunicas con nosotros.
          </p>
        </section>

        <section>
          <h2>Datos que recopilamos</h2>
          <ul>
            <li><strong>Datos de contacto:</strong> nombre, email, teléfono, dirección postal cuando corresponde.</li>
            <li><strong>Datos de reserva y prestación:</strong> fecha de la sesión, ubicación, preferencias, información contractual y de pago.</li>
            <li><strong>Contenido multimedia:</strong> fotografías y videos que nos confías para editar y entregar (tus imágenes y las de tus invitados).</li>
            <li><strong>Datos técnicos:</strong> información de navegación (cookies, IP, dispositivo) si usas nuestra web.</li>
          </ul>
        </section>

        <section>
          <h2>¿Para qué usamos tus datos?</h2>
          <p>Utilizamos tu información para:</p>
          <ul>
            <li>Gestionar reservas, confirmar citas y coordinar sesiones fotográficas.</li>
            <li>Procesar pagos, emitir facturas y cumplir obligaciones contractuales.</li>
            <li>Editar, almacenar y entregarte las fotografías y videos solicitados.</li>
            <li>Enviar comunicaciones relacionadas con reservas, ofertas relevantes o cambios en nuestros servicios (podés darte de baja en cualquier momento).</li>
            <li>Mejorar la web y la experiencia de usuario mediante datos técnicos y analíticos.</li>
          </ul>
        </section>

        <section>
          <h2>Base legal</h2>
          <p>
            Cuando aplicable, tratamos tus datos con tu consentimiento (por ejemplo, envío de newsletters), para ejecutar un contrato (servicios de fotografía),
            y para cumplir obligaciones legales (facturación). También podemos tener intereses legítimos para la gestión operativa y seguridad.
          </p>
        </section>

        <section>
          <h2>Conservación de datos</h2>
          <p>
            Conservamos la información necesaria mientras dure la relación contractual y según lo exijan las normas fiscales para la facturación.
            Las fotografías y archivos de las sesiones se almacenan y se entregan según lo acordado; si deseas que eliminemos tus imágenes de nuestros archivos,
            contactanos y analizaremos la solicitud (nota: la eliminación puede limitar la posibilidad de reimpresiones o copias futuras).
          </p>
        </section>

        <section>
          <h2>Compartir con terceros</h2>
          <p>
            Para prestar el servicio podemos compartir datos con:
            proveedores de pago, servicios de almacenamiento en la nube, laboratorios de impresión, herramientas de email y plataformas de entrega digital.
            Solo compartimos lo necesario y exigimos medidas de seguridad a nuestros proveedores.
          </p>
        </section>

        <section>
          <h2>Cookies y herramientas de análisis</h2>
          <p>
            Usamos cookies y servicios de análisis (por ejemplo Google Analytics) para comprender el tráfico y mejorar la web. Podés gestionar o bloquear cookies
            desde la configuración de tu navegador; tené en cuenta que ciertas funciones del sitio podrían dejar de funcionar correctamente.
          </p>
        </section>

        <section>
          <h2>Tus derechos</h2>
          <p>
            Podés ejercer los derechos que reconozcan las leyes aplicables: acceso, rectificación, supresión, limitación del tratamiento, oposición y portabilidad.
            Para solicitar cualquiera de estos derechos contactanos a continuación.
          </p>
        </section>

        <section>
          <h2>Seguridad</h2>
          <p>
            Implementamos medidas técnicas y organizativas razonables para proteger tus datos contra accesos no autorizados, pérdida o divulgación.
            Sin embargo, ningún sistema es 100% infalible; si detectás una brecha de seguridad que involucre tus datos, informanos de inmediato.
          </p>
        </section>

        <section>
          <h2>Menores</h2>
          <p>
            No solicitamos intencionalmente datos personales de menores sin el consentimiento de sus padres o tutores. Si sos padre/madre o tutor y creés que
            tenemos datos de un menor sin permiso, contactanos para tomar las acciones necesarias.
          </p>
        </section>

        <section>
          <h2>Contacto</h2>
          <p>
            Para consultas sobre privacidad, ejercer derechos o solicitar la eliminación de datos, escribí a:
            <br />
            <a href="mailto:scgroup@gmail.com">scgroup@gmail.com</a>
            <br />
            También podés comunicarnoste por teléfono al <strong>+54 381 681-8108</strong>.
          </p>
        </section>

        <footer className="pp-footer">
          <p>
            Esta Política de Privacidad describe cómo tratamos tus datos. No constituye asesoramiento legal. Si necesitás seguridad legal adicional para tu caso,
            consultá con un profesional.
          </p>
        </footer>
      </article>
    </main>
      <Footer />
    </>
  );
}
